module.exports = __webpack_public_path__ + "static/shoe-dog-e57d3f429fc57b438d728c91964a74ff.jpg";